const infomational_banner_reviews = () => {
    let reviewOptions = [
        [],
        [
            {
                id: 0,
                text: 'Vehicle Replacement Plus',
            },
            {
                id: 1,
                text: 'Back to Invoice GAP Insurance',
            },
            {
                id: 2,
                text: 'Contract Hire Plus',
            },
            {
                id: 3,
                text: 'Agreed Value GAP Insurance',
            },
            {
                id: 4,
                text: 'Van GAP Insurance',
            },
        ],
        [],
        [
            {
                id: 0,
                text: 'Tyre and Alloy Wheel Insurance',
            },
            {
                id: 1,
                text: 'Cycle Insurance',
            },
            {
                id: 2,
                text: 'Scratch and Dent Insurance',
            },
            {
                id: 3,
                text: 'Excess Cover',
            },
            {
                id: 4,
                text: 'Keycare',
            },
        ],
    ];

    $('.info-banner__button--review-single').on('click', function() {
        let index = $(this).data('index');

        $('.info-banner__select-wrapper').hide();
        $('.info-banner__button').removeClass('info-banner__button--active');
        $(this).addClass('info-banner__button--active');
        $('.info-banner__reviews-wrapper')
            .removeClass('info-banner__reviews-wrapper--active')
            .hide();
        $('.info-banner__reviews-wrapper[data-index="' + index + '"]')
            .addClass('info-banner__reviews-wrapper--active')
            .fadeIn();
    });


    $('.info-banner__button--review-multiple').on('click', function() {
        let index = $(this).data('index');

        $('.info-banner__button').removeClass('info-banner__button--active');
        $(this).addClass('info-banner__button--active');
        $('.info-banner__select-wrapper').show();
        $('.info-banner__select--reviews').empty();
        $('.info-banner__reviews-wrapper')
            .removeClass('info-banner__reviews-wrapper--active')
            .hide();
        $('.info-banner__reviews-wrapper[data-index="' + index + '"]')
            .addClass('info-banner__reviews-wrapper--active')
            .fadeIn();

        $('.info-banner__reviews-wrapper--active .info-banner__review-block--multiple[data-index="0"]').show();

        $('.info-banner__select--reviews').select2({
            data: reviewOptions[index],
            width: 'auto',
            selectionCssClass: 'info-banner__custom-select',
            dropdownCssClass: 'info-banner__custom-dropdown',
        });

        $('.info-banner__select--reviews').on('change', function() {
            let index = $(this).val();

            $('.info-banner__review-block--multiple').hide();
            $('.info-banner__reviews-wrapper--active .info-banner__review-block--multiple[data-index="' + index + '"]').fadeIn();
        });
    });
}

export default infomational_banner_reviews;